<template>
  <div>
  <div class="wrapper">
    <MediaLazyImage
      class="h-auto w-full"
      :src="baseUrl"
      :blurhash="currentMedia.blurhash"
      :width="width"
      :height="height"
      alt=""
    />
  </div>
    <div class="mx-1.5">
      <div
        class="pt-3 text-base font-medium text-gray-900 flex-1 flex items-center px-0.5"
      >
        <div class="flex-1">
          {{ currentMedia.org_name }}
        </div>
      </div>

      <dl class="mt-2 divide-y divide-gray-200 border-b border-t border-gray-200">
        <div
          v-for="key in Object.keys(info)"
          :key="key"
          class="flex justify-between py-1.5 px-0.5 text-sm"
        >
          <dt
            class="text-gray-500"
            v-html="key"
          />

          <dd
            class="whitespace-nowrap text-gray-900  font-medium"
            v-html="info[key]"
          />
        </div>
      </dl>
    </div>
    <div>
      <h3 class="font-medium text-gray-900">
        Description
      </h3>
      <div class="mt-2 flex items-center justify-between">
        <p class="text-sm italic text-gray-500">
          Add a description to this image.
        </p>
        <button
          type="button"
          class="relative flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        >
          <span class="absolute -inset-1.5" />
          <PencilIcon
            class="h-5 w-5"
            aria-hidden="true"
          />
          <span class="sr-only">Add description</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, toRefs } from 'vue'
import MediaLazyImage from './MediaLazyImage.vue'
import { useTemplateFilter } from '@/composables/useTemplateFilter.js'
import { useMediaStore } from '@/pinia/MediaStore'
import { storeToRefs } from 'pinia'
import {
  Bars4Icon,
  MagnifyingGlassIcon,
  PencilIcon,
  PlusIcon,
  Squares2X2Icon as Squares2X2IconMini
} from '@heroicons/vue/20/solid'

const { formatFileSize } = useTemplateFilter()

const mediaStore = useMediaStore()
const { mediaFile, isLoading, currentMedia, currentItem } = storeToRefs(mediaStore)

const baseUrl = computed(() => currentMedia.value.base_url)

const wrapper = ref()

const width = computed(() => wrapper.value?.clientWidth)
const height = computed(() => wrapper.value?.clientHeight)

const info = ref({
  Dateigröße: currentMedia.value.file ? formatFileSize(currentMedia.value.file.size) : 0,
  Dimension: currentMedia.value.file ? `${currentMedia.value.file.width} &times; ${currentMedia.value.file.height}` : '',
  Mimetype: currentMedia.value.file ? currentMedia.value.file.mimeType : ''
})

</script>
